import script from "./ProjectEvaluationArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectEvaluationArea.vue?vue&type=script&setup=true&lang=js"

import "./ProjectEvaluationArea.vue?vue&type=style&index=0&id=10c2eb06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c2eb06"]])

export default __exports__